import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { DataError, TableLoading, Tooltip } from "@digital-services/ui";

import { NoResultsWithIcon } from "@components/from_fota/NoResultsWithIcon";

import { useGetApplications } from "@application/services/use-get-applications";

import { ApplicationTile } from "./ApplicationTile";

export const ApplicationsPanel: FunctionComponent = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "applications" });

  const { applications, isLoading, error } = useGetApplications();

  if (isLoading)
    return (
      <>
        <TableLoading isDarker />
      </>
    );

  if (error) {
    return <DataError message={t("load.error.message")} variant="primary" />;
  }

  if (applications === undefined || applications.length === 0)
    return (
      <div data-testid="application-no-data">
        <NoResultsWithIcon message={t("load.none.message")} />
      </div>
    );

  return (
    <div className="flex flex-wrap gap-10" data-testid="application-panel">
      {applications.map(item => {
        if (error) {
          const key1 = `application-tooltip-for-${item.id}`;
          const key2 = `application-${item.id}-with-error`;
          return (
            <Tooltip message={error} key={key1}>
              <ApplicationTile key={key2} applicationData={item} />
            </Tooltip>
          );
        }

        return (
          <ApplicationTile
            key={`application-${item.id}`}
            applicationData={item}
          />
        );
      })}
    </div>
  );
};
